import enUS from './en-US.json';
import heIL from './he-IL.json';

const translations = {
  'en-US': enUS,
  'he-IL': heIL
};

const usei18n = (language) => {
  const i18n = (key) => {
    const translation = translations[language][key];
    if (!translation) {
      console.warn(`Missing translation for key: ${key} in language: ${language}`);
      return key; // Fallback to the key itself if translation is missing
    }
    return translation;
  };
  return i18n;
};

const getAppTitle = (language) => {
  const translation = translations[language] && translations[language]['appTitle'];
  if (!translation) {
    console.warn(`Missing appTitle translation for language: ${language}`);
    return 'Dose O\'Clock'; // Fallback title
  }
  return translation;
};

export { getAppTitle, usei18n };
